/* Lotus Wheel social-proof — on scroll the headline numbers count up and the
   cards/rating fade in. Progressive enhancement (final values without JS);
   skipped for reduced motion. */
class SocialReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.counters = Array.from(this.querySelectorAll('[data-countup]'));
    this.counters.forEach((el) => {
      const raw = el.textContent;
      el.dataset.countraw = raw;
      const prefix = (raw.match(/^[^\d]*/) || [''])[0];
      const suffix = (raw.match(/[^\d]*$/) || [''])[0];
      el.textContent = prefix + '0' + suffix;
    });

    this.classList.add('is-armed');
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.classList.add('is-revealed');
          this.counters.forEach((el) => this.countUp(el));
          this.observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    this.observer.observe(this);
  }

  countUp(el) {
    const raw = el.dataset.countraw || el.textContent;
    const target = parseInt(raw.replace(/[^\d]/g, ''), 10);
    if (Number.isNaN(target)) {
      el.textContent = raw;
      return;
    }
    const prefix = (raw.match(/^[^\d]*/) || [''])[0];
    const suffix = (raw.match(/[^\d]*$/) || [''])[0];
    const duration = 1300;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + Math.round(eased * target).toLocaleString() + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = prefix + target.toLocaleString() + suffix;
    };
    requestAnimationFrame(tick);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define('social-reveal', SocialReveal);
